import footprintImg from "../images/FOOTPRINT.png";
import CountryMap from "./countryMap";

const Project = () => {
  return (
    <section>
      <div className="pb-5 position-relative">
        <div className="position-absolute mx-auto text-center start-0 end-0 footprint-img-position">
          <img src={footprintImg} className="img-fluid" alt="" />
        </div>
        <h1 className="text-center fs-56 lh-64 gilroy-bold mt-13 py-5">
          Our Global Footprint
        </h1>
      </div>
      <CountryMap />
    </section>
  );
};

export default Project;
